import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/recruit/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/recruit/settings/account" })
  },
  component: () => null,
})
